import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

// Landing shown when a universal link (https://cruxlabs.app/crag/:id) is opened
// but the OS did NOT hand it to the app — i.e. the app isn't installed (or link
// verification is still pending), or it was opened on desktop. When the app IS
// installed and verified, iOS/Android intercept the link and this page never
// renders.

const PLAY_URL =
  process.env.REACT_APP_GOOGLE_PLAY_URL ||
  'https://play.google.com/store/apps/details?id=com.horiondev.cruxlabs.android';
const APP_STORE_URL =
  process.env.REACT_APP_APP_STORE_URL ||
  'https://apps.apple.com/app/cruxlabs/id000000000';

const CragRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    // On mobile, nudge the app open via the custom scheme (covers "installed but
    // App Link not yet verified"). Skipped on desktop to avoid a browser error.
    if (!id) return;
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (!isMobile) return;
    const t = window.setTimeout(() => {
      window.location.href = `cruxlabs://crag/${id}`;
    }, 500);
    return () => window.clearTimeout(t);
  }, [id]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f4f4f5',
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        color: '#0a0a0a',
        padding: 24,
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 400,
          background: '#fff',
          border: '1px solid #e5e7eb',
          borderRadius: 14,
          padding: '32px 30px',
          textAlign: 'center',
          boxShadow: '0 4px 24px rgba(0,0,0,.06)',
        }}
      >
        <h1 style={{ fontSize: 20, fontWeight: 600, margin: '0 0 6px' }}>
          Open this crag in CruxLabs
        </h1>
        <p style={{ color: '#6b7280', fontSize: 14, margin: '0 0 20px' }}>
          {id ? `Crag #${id}` : 'Unknown crag'} — get the app to view the 3D topo.
        </p>

        {id && (
          <a
            href={`cruxlabs://crag/${id}`}
            style={{
              display: 'block',
              padding: '13px',
              borderRadius: 8,
              background: '#0a0a0a',
              color: '#fff',
              fontWeight: 600,
              textDecoration: 'none',
              marginBottom: 20,
            }}
          >
            Open in the app
          </a>
        )}

        <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
          <a href={APP_STORE_URL} style={{ color: '#0a0a0a', fontSize: 13 }}>
            App Store
          </a>
          <span style={{ color: '#d1d5db' }}>·</span>
          <a href={PLAY_URL} style={{ color: '#0a0a0a', fontSize: 13 }}>
            Google Play
          </a>
        </div>
      </div>
    </div>
  );
};

export default CragRedirect;
